import _styled from "@emotion/styled-base";
import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as React from "react";
import { css } from "@emotion/core";
import ReactDayPicker from "react-day-picker";
import { border, flexbox, layout, position, space, width } from "styled-system";
import { emRhythm } from "../css";
import { MODIFIERS } from "./constants";
import DatePickerGlobalStyles from "./DatePickerGlobalStyles";
import DatePickerNavBar from "./DatePickerNavBar";

var StyledReactDayPicker = /*#__PURE__*/_styled(ReactDayPicker, {
  target: "eke9vve0"
})(function (_ref) {
  var theme = _ref.theme;
  return /*#__PURE__*/css("display:inline-block;padding:", emRhythm(0.375), ";border:1px solid ", theme.colors.border, ";border-radius:", theme.radii.md, ";background:", theme.colors.white, ";overflow:hidden;");
}, border, flexbox, layout, position, space, width);

var DatePicker = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DatePicker, _React$Component);

  function DatePicker() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "onDayClick", function (day, modifiers) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          allowClear = _this$props.allowClear; // istanbul ignore next

      if (onChange == null || modifiers[MODIFIERS.DISABLED]) {
        return;
      }

      if (modifiers[MODIFIERS.SELECTED]) {
        if (allowClear) {
          onChange(null);
        }

        return;
      }

      onChange(day);
    });

    return _this;
  }

  var _proto = DatePicker.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        onChange = _this$props2.onChange,
        allowClear = _this$props2.allowClear,
        overlay = _this$props2.overlay,
        props = _objectWithoutPropertiesLoose(_this$props2, ["onChange", "allowClear", "overlay"]);

    return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(DatePickerGlobalStyles, null), ___EmotionJSX(StyledReactDayPicker, _extends({
      onDayClick: this.onDayClick,
      navbarElement: ___EmotionJSX(DatePickerNavBar, null)
    }, props)));
  };

  return DatePicker;
}(React.Component);

_defineProperty(DatePicker, "defaultProps", {
  onChange: undefined,
  allowClear: false,
  overlay: false
});

export { DatePicker as default };